import { render, staticRenderFns } from "./format.vue?vue&type=template&id=0e102826&scoped=true&"
import script from "./format.vue?vue&type=script&lang=js&"
export * from "./format.vue?vue&type=script&lang=js&"
import style0 from "./format.vue?vue&type=style&index=0&id=0e102826&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e102826",
  null
  
)

export default component.exports